import { z } from "zod";

export const LoginSchema = z.object({
  emailOrConnectId: z.union([
    z
      .string()
      .email("Veuillez entrer un email ou identifiant Connect’Events valide"),
    z.string().length(10),
  ]),
  password: z.string().min(1),
});

export const defaultLoginValues = {
  emailOrConnectId: "",
  password: "",
};

export type LoginForm = z.infer<typeof LoginSchema>;
